import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '@/store/authStore'
import { teacherPriorityApi } from '@/services/api/teacherPriority'
import { adminOnBehalfApi } from '@/services/api/adminOnBehalf'
import { directorApi } from '@/services/api/director'
import { hrApi } from '@/services/api/hr'

export function useDirectorEnabled(): boolean {
  const role = useAuthStore(s => s.user?.role)

  const teacherQ = useQuery({
    queryKey: ['director-gate-settings'],
    queryFn: () => teacherPriorityApi.getDirectorGateSettings(),
    enabled: role === 'teacher',
    staleTime: 30 * 1000,
    retry: 1,
  })
  const adminQ = useQuery({
    queryKey: ['on-behalf-gate-settings'],
    queryFn: () => adminOnBehalfApi.gateSettings(),
    enabled: role === 'admin',
    staleTime: 30 * 1000,
    retry: 1,
  })
  const directorQ = useQuery({
    queryKey: ['director-config'],
    queryFn: () => directorApi.getConfig(),
    enabled: role === 'director',
    staleTime: 30 * 1000,
    retry: 1,
  })
  const hrQ = useQuery({
    queryKey: ['hr-my-scopes'],
    queryFn: () => hrApi.getMyScopes(),
    enabled: role === 'hr',
    staleTime: 5 * 60 * 1000,
    retry: false,
  })

  if (role === 'teacher') return teacherQ.data?.director_enabled === true
  if (role === 'admin') return adminQ.data?.director_enabled === true
  if (role === 'director') return directorQ.data?.director_enabled === true
  if (role === 'hr') return hrQ.data?.director_enabled === true
  return false
}
